import React from 'react';

const MmcBadge = ({ children, className = '', ...props }) => {
    return (
        <span className={`mmc-badge ${className}`} {...props}>
            {children}
        </span>
    );
};

export default MmcBadge;
